import React, { useState, useEffect } from 'react';
import { Box, Slider, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, IconButton, Typography } from '@mui/material';

import axios from "axios";
import { HugeiconsIcon } from '@hugeicons/react';
import {
  Camera01Icon, Cancel01Icon, Car05Icon, Chair01Icon, Dish02Icon, Dumbbell01Icon, FlashIcon, GeometricShapes01Icon,
  Motorbike02Icon, ShoppingCart02Icon, Store01Icon, TShirtIcon, TvSmartIcon,
  Upload01Icon
} from '@hugeicons/core-free-icons';
// import ReactDOMServer from "react-dom/server";

const iconList = [
  { name: 'Car05Icon', icon: Car05Icon },
  { name: 'GeometricShapes01Icon', icon: GeometricShapes01Icon },
  { name: 'Motorbike02Icon', icon: Motorbike02Icon },
  { name: 'FlashIcon', icon: FlashIcon },
  { name: 'ShoppingCart02Icon', icon: ShoppingCart02Icon },
  { name: 'TvSmartIcon', icon: TvSmartIcon },
  { name: 'HangerIcon', icon: TShirtIcon },
  { name: 'Dish02Icon', icon: Dish02Icon },
  { name: 'Dumbbell01Icon', icon: Dumbbell01Icon },
  { name: 'Chair01Icon', icon: Chair01Icon },
  { name: 'Store01Icon', icon: Store01Icon },
  { name: 'Camera01Icon', icon: Camera01Icon },
];


const EditCategoryPopup = ({ open, onClose, categoryData, onSuccess, setAlertInfo }) => {
  const [categoryName, setCategoryName] = useState('');
  const [color, setColor] = useState('#E89623');
  const [rgb, setRgb] = useState({ r: 232, g: 150, b: 35 });
  const [photo, setPhoto] = useState(null);
  const [hue, setHue] = useState(30);
  const [showIcons, setShowIcons] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState('');
  const [categoryImageFile, setCategoryImageFile] = React.useState(null);


  const rgbToHue = (r, g, b) => {
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let hue = 0;

    if (max === min) hue = 0;
    else if (max === r) hue = (60 * ((g - b) / (max - min)) + 360) % 360;
    else if (max === g) hue = (60 * ((b - r) / (max - min)) + 120) % 360;
    else hue = (60 * ((r - g) / (max - min)) + 240) % 360;

    return hue;
  };

  useEffect(() => {
    if (categoryData && open) {
      setCategoryName(categoryData.category_name || '');
      const hex = categoryData.color || '#E89623';
      setColor(hex);
      const bigint = parseInt(hex.slice(1), 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      setRgb({ r, g, b });
      setHue(rgbToHue(r, g, b));

      if (categoryData.category_image) {
        const fullImageUrl = categoryData.category_image.startsWith('http')
          ? categoryData.category_image
          : `http://127.0.0.1:8000${categoryData.category_image}`;
        setPhoto(fullImageUrl);
        setSelectedIcon(null);
      } else if (categoryData.category_icon) {
        setSelectedIcon(categoryData.category_icon); // set by icon name string
        setPhoto(null);
      }
    }
  }, [categoryData, open]);



  const handleHexChange = (e) => {
    let hex = e.target.value;
    if (/^#([0-9A-Fa-f]{0,6})$/.test(hex)) {
      setColor(hex);
      if (hex.length === 7) {
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;
        setRgb({ r, g, b });

        const calculatedHue = rgbToHue(r, g, b);
        setHue(calculatedHue);
      }
    }
  };

  const handleRGBChange = (e, key) => {
    const value = Math.min(255, Math.max(0, Number(e.target.value)));
    setRgb((prev) => ({ ...prev, [key]: value }));

    const { r, g, b } = { ...rgb, [key]: value };
    const hex = rgbToHex(r, g, b);
    setColor(hex);

    const calculatedHue = rgbToHue(r, g, b);
    setHue(calculatedHue);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhoto(URL.createObjectURL(file));
      setCategoryImageFile(file);
      setSelectedIcon(null);
    }
  };

  const hsvToRgb = (h, s, v) => {
    let r, g, b;
    const i = Math.floor(h * 6);
    const f = h * 6 - i;
    const p = v * (1 - s);
    const q = v * (1 - f * s);
    const t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0: [r, g, b] = [v, t, p]; break;
      case 1: [r, g, b] = [q, v, p]; break;
      case 2: [r, g, b] = [p, v, t]; break;
      case 3: [r, g, b] = [p, q, v]; break;
      case 4: [r, g, b] = [t, p, v]; break;
      case 5: [r, g, b] = [v, p, q]; break;
      default: [r, g, b] = [0, 0, 0]; break;
    }

    return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
  };

  const rgbToHex = (r, g, b) => {
    const toHex = (n) => n.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };

  const handleHueChange = (event, newValue) => {
    setHue(newValue);
  };

  const handleGradientChange = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width;
    const y = (e.clientY - rect.top) / rect.height;

    const [r, g, b] = hsvToRgb(hue / 360, x, 1 - y);
    setColor(rgbToHex(r, g, b));
    setRgb({ r, g, b });
  };

  const handleSaveChanges = async () => {
    try {
      const categoryId = categoryData?.catId;
      if (!categoryId) {
        setAlertInfo({ open: true, type: 'error', message: 'Category ID not found!' });
        return;
      }

      const formData = new FormData();
      formData.append("id", categoryId);
      formData.append("category_name", categoryName);
      formData.append("color", color);
      formData.append("user", 1);

      if (selectedIcon) {
        formData.append("category_image", "");
        formData.append("category_icon", selectedIcon);
      } else if (categoryImageFile) {
        formData.append("category_image", categoryImageFile);
        formData.append("category_icon", "");
      }

      const response = await axios.put(
        `http://127.0.0.1:8000/categories/category-list/1`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // console.log("Update response:", response.data);

      if (response.status === 200) {
        onClose();

        if (onSuccess) onSuccess(response.data);
      }

    } catch (error) {
      setAlertInfo({ open: true, type: 'error', message: 'Something went wrong!' });
    }
  };


  const handleUploadClick = () => {
    setShowIcons((prev) => !prev);
  };
  const handleIconSelect = (name) => {
    setSelectedIcon(name);
    setPhoto(null);
    setCategoryImageFile(null);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="m" PaperProps={{ sx: { borderRadius: '20px' } }}>
      <DialogTitle sx={{ backgroundColor: '#F0F4FF', color: '#000', fontWeight: 'bold', textAlign: 'start' }}>
        Edit Category
        <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <HugeiconsIcon icon={Cancel01Icon} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box mt={1} mb={1}>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>Category Name</Typography>
          <TextField
            fullWidth
            size="small"
            value={categoryName}
            onChange={(e) => setCategoryName(e.target.value)}
            placeholder="Enter category name"
            sx={{
              width: { xs: '100%', sm: '50%' },
              '& .MuiOutlinedInput-root': {
                borderRadius: '15px',
                backgroundColor: 'white',
              },
            }}
          />
        </Box>

        <Box display="flex" flexDirection="column" alignItems="center" gap={1} mt={1}>
          <Box display="flex" alignItems="center" gap={2} mt={2} width="100%">
            <Box sx={{ width: '150px', height: '100px', backgroundColor: color, borderRadius: '15px' }} />
            <Box
              sx={{
                width: '100%',
                height: '100px',
                background: `linear-gradient(to right, #fff, hsl(${hue}, 100%, 50%)), linear-gradient(to top, #000, transparent)`,
                backgroundBlendMode: 'multiply',
                borderRadius: '15px',
                cursor: 'crosshair',
              }}
              onMouseDown={handleGradientChange}
              onMouseMove={(e) => e.buttons === 1 && handleGradientChange(e)}
            />
          </Box>
          <Slider
            min={0}
            max={360}
            value={hue}
            onChange={handleHueChange}
            sx={{
              width: '100%',
              height: '15px',
              '& .MuiSlider-root': {
                outline: 'none',
              },
              '& .MuiSlider-track': {
                background: 'transparent',
              },
              '& .MuiSlider-rail': {
                background: 'linear-gradient(to right, red, yellow, lime, cyan, blue, magenta, red)',
                opacity: 1,
                outline: 'none',
              },
              '& .MuiSlider-thumb': {
                width: '25px',
                height: '25px',
                backgroundColor: `hsl(${hue}, 100%, 50%)`,
                outline: 'none',
                '&:focus, &:hover, &.Mui-active, &:focus-visible': {
                  outline: 'none',
                },
                '&:before': {
                  display: 'none',
                },
              },
            }}
          />
        </Box>

        <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
          {['Hex', 'R', 'G', 'B'].map((label, idx) => (
            <Box key={label} flex={{ xs: '1 1 45%', sm: '1 1 20%' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>{label}</Typography>
              <TextField
                fullWidth
                size="small"
                type={label === 'Hex' ? 'text' : 'number'}
                value={label === 'Hex' ? color : rgb[label.toLowerCase()]}
                onChange={(e) =>
                  label === 'Hex' ? handleHexChange(e) : handleRGBChange(e, label.toLowerCase())}
                placeholder={label === 'Hex' ? '#000000' : '0-255'}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '15px',
                    backgroundColor: 'white',
                  }
                }}
              />
            </Box>
          ))}
        </Box>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<HugeiconsIcon icon={Upload01Icon} />}
          sx={{
            mt: 2,
            textTransform: 'none',
            borderRadius: '50px',
            fontWeight: 'bold',
            borderStyle: 'dashed',
            borderColor: '#D9DDE3',
            backgroundColor: '#F3F5F9',
            color: '#7A7F88',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 1,
          }}
          onClick={handleUploadClick}
        >
          Select Icon
        </Button>
        {showIcons && (
          <Box mt={2} display="flex" flexDirection="column" alignItems="center" gap={2}>
            <Box display="flex" gap={2} justifyContent="center">
              {iconList.map(({ name, icon }) => (
                <Box
                  key={name}
                  data-icon-name={name}
                  sx={{
                    cursor: 'pointer',
                    border: selectedIcon === name ? '2px solid #0b57d0' : '2px solid transparent',
                    borderRadius: '5px',
                    padding: '3px',
                    backgroundColor: selectedIcon === name ? '#e0f7fa' : 'transparent',
                  }}
                  onClick={() => handleIconSelect(name)}
                >
                  <HugeiconsIcon icon={icon} size={25} color="currentColor"
                    style={{ fill: "currentColor", strokeWidth: 0 }}
                  />
                </Box>
              ))}

            </Box>
            <Button
              variant="contained"
              size="medium"
              sx={{ textTransform: 'none', borderRadius: '20px' }}
              onClick={() => document.getElementById('file-input').click()}
            >
              Upload Icon from Device
            </Button>
          </Box>

        )}
        <Typography variant="body2" sx={{ color: '#777', mt: 1, textAlign: 'center' }}>
          Upload photo relevant to the category. So it will identify the category directly by the photo uploaded.
        </Typography>

        <input
          type="file"
          id="file-input"
          accept="image/*"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />

        {photo && (
          <Box mt={2} sx={{ textAlign: 'center' }}>
            <img
              src={photo}
              alt="Uploaded"
              style={{ maxWidth: '100%', maxHeight: '150px', borderRadius: '15px' }}
            />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'end', boxShadow: '0px -2px 5px rgba(0, 0, 0, 0.2)' }}>
        <Button onClick={onClose} sx={{ textTransform: 'none', color: '#666' }}>Cancel</Button>
        <Button variant="contained"
          sx={{ textTransform: 'none', ml: 1, backgroundColor: '#0b57d0', borderRadius: '20px' }}
          onClick={handleSaveChanges}
        >
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditCategoryPopup;
